/**
 * @see https://docs.pos.payyo.ch/docs/resources/payments/#payment-method-object
 *
 * @enum {string}
 */
const PayyoTransactionType = Object.freeze({
    CARD_MOTO: 'card',
    CARD_PRESENT: 'card_present',
});

module.exports = PayyoTransactionType;
